import { useRef } from 'react'
import Icon24 from 'builder/components/Icon'
import { useI18n } from 'builder/hooks/useI18n'
import { useLocalStorage } from 'builder/hooks/useLocalStorage'
import { LOCAL_STORAGE_JS_CLICKED_CUSTOMIZE_MODAL_KEY } from 'builder/components/FindJob/SearchBar/constants'
import { useStepByStepFeature } from '../../StepByStepFlow/hooks/useStepByStepFeature'
import { Container, ToolTip } from './styles'

export const TailoringFromPublicJobBoardPanelButton = () => {
  const { i18n } = useI18n()
  const [clickedButton] = useLocalStorage<boolean>(
    LOCAL_STORAGE_JS_CLICKED_CUSTOMIZE_MODAL_KEY,
    false,
  )

  const buttonRef = useRef<HTMLDivElement>(null)
  const toolTipRef = useRef<HTMLDivElement>(null)

  const { isRbpStepFlowActive } = useStepByStepFeature()

  return (
    <Container ref={buttonRef}>
      <Icon24.Grid />
      {!isRbpStepFlowActive && !clickedButton && (
        <ToolTip
          ref={toolTipRef}
          dangerouslySetInnerHTML={{
            __html: i18n.t('builder.prefill_resume.auto_tailoring_view.panel_button_tooltip'),
          }}
        />
      )}
    </Container>
  )
}
